<template>

	<div class="form_field form_field_select">

		<label class="label" v-if="label" :title="label">
			{{label}}
		</label>

		<div class="value">
			<select :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
				<option v-for="(item, i) of options" v-html="item.label" :value="item.key"></option>
			</select>
			
		</div>
		
	</div>

</template>

<script>

	export default {
		name: "FormSelect",
		inject: [
			'trans'
		],
		props: {
			type: String,
			modelValue: String|Number,	
			label: String,
			options: Array
		},
		data() {
			return { }
		},
		components: {},
		methods: {}
	}

</script>

<style lang="scss">

</style>